import { useIntl, defineMessages } from 'react-intl'
import { formatCurrency } from '../../../../../../helpers/formatters'
import { NATIONAL_AVG_DOWN_PAYMENT } from '../EstimatedMonthlyPaymentBreakdown'
import { Box, Flex, Text, Heading, Card } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  mortgageInsurance: {
    id: 'EstimatedMonthlyPaymentBreakdown.mortgageInsurance',
    defaultMessage: 'Mortgage insurance'
  },
  mortgageInsuranceDescription: {
    id: 'EstimatedMonthlyPaymentBreakdown.mortgageInsuranceDescription',
    defaultMessage: 'Since your down payment is {pctDown}%'
  }
})

export interface EstimatedMonthlyPaymentBreakdownMortgageInsuranceProps {
  mortgageInsurance: number
  downPaymentPercentage: number
}

export const EstimatedMonthlyPaymentBreakdownMortgageInsurance = ({
  mortgageInsurance,
  downPaymentPercentage
}: EstimatedMonthlyPaymentBreakdownMortgageInsuranceProps) => {
  const intl = useIntl()

  return (
    <Card p={3}>
      <Flex justify='space-between' align='center'>
        <Flex gap={2} align='center'>
          <Box bg='primary.600' width={3} height={3} borderRadius='50%' />
          <Heading as='h4' size={['2xs', 'xs', 'sm']}>
            {intl.formatMessage(MSG.mortgageInsurance)}
          </Heading>
        </Flex>
        <Text
          mb={0}
          color='neutral.900'
          size={['xs', 'sm', 'md']}
          fontWeight='semibold'
          style={{ fontVariant: 'tabular-nums' }}
        >
          {formatCurrency(mortgageInsurance)}
        </Text>
      </Flex>
      <Text ml={5} as='span' size={['2xs', 'xs', 'sm']} display='block'>
        {intl.formatMessage(MSG.mortgageInsuranceDescription, {
          pctDown:
            parseFloat(downPaymentPercentage.toFixed(2))
              .toString()
              .replace(/(\.\d*?[1-9])0+$/, '$1') || NATIONAL_AVG_DOWN_PAYMENT * 100
        })}
      </Text>
    </Card>
  )
}
